// Distribution only: who owns the booking and takes the channel commission.
// The marketing channels, commercial agreements and individual broker names
// that used to live here moved to typeOfStay, salesPerson and the new
// marketing attribution fields -- a booking can be several of those at once, so
// one field could never answer any of them.
export enum ReservationChannel {
  BIRDNEST = 'birdnest',
  AIRBNB = 'airbnb',
  BOOKING = 'booking',
  EXPEDIA = 'expedia',
  VRBO = 'vrbo',
  AGODA = 'agoda'
}
